module.exports = __webpack_public_path__ + "static/media/whatsapp.70f3d23c.svg";